import {Component, OnInit} from '@angular/core';
import {ConfService} from '../conf.service';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {ActivatedRoute} from '@angular/router';
import {KongService} from '../kong.service';

export interface AvailableMetrics {
    id: number;
    itemName: string;
    metric: string;
}

@Component({
    selector: 'app-dashboard-metrics',
    templateUrl: './dashboard-metrics.component.html',
    styleUrls: ['./dashboard-metrics.component.scss']
})
export class DashboardMetricsComponent implements OnInit {
    partner: any;
    account: any;
    APIName: any;
    version: any;

    creationTime: any;
    connectionTime:any;
    createdAt: any;
    currentTime: any;
    overAllRequestCount: any;
    averageLatency:any;

    service: any;
    loading = true;
    messagesAndExceptions: any;
    loadingMetrics = false;

    availableMetrics: AvailableMetrics[] = [];

    metricsToFind = [];
    computedGraphs = [];
    metricsError: any;

    graphSize = 'col-md-4 col-lg-4 col-sm-12 col-xs-12';

    settings = {
        text: 'Select attribute(s) to retrieve metrics',
        selectAllText: 'Select All',
        unSelectAllText: 'Unselect All',
        enableSearchFilter: false,
        autoPosition: true,
        badgeShowLimit: 4
    };

    timeframes = [
        {displayName: '1 Hour', value: '1_hour'},
        {displayName: '4 Hours', value: '4_hours'},
        {displayName: '1 Day', value: '1_day'},
        {displayName: '2 Days', value: '2_days'},
        {displayName: '1 Week', value: '1_week'}
    ];

    graphDisplayTypes = [
        {displayName: 'Bars', value: 'bars'},
        {displayName: 'Lines', value: 'line'},
        {displayName: 'Areas', value: 'area'},
    ];
    selectedGraphDisplayType = 'bars';

    selectedTimeframe = '1_week';
    isPluginNotAvailable = false;
    displayPluginSuccessfullyConfigured = false;

    constructor(private route: ActivatedRoute, private confpost: ConfService, private platform: LeftpanelComponent, private kong: KongService) {
    }

    ngOnInit() {
        // if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
        //   this.platform.initialisePlatform();
        // }
        // if (this.location['_platformLocation'].location.pathname === '/dashboard-metrics') {
        this.overAllRequestCount = 0;
        this.averageLatency = 0;
        this.connectionTime = 0;
        this.route.queryParams
            .subscribe(async params => {
                this.partner = params.partner;
                this.account = params.account;
                this.APIName = params.entity;
                this.version = params.version;
                if (this.partner && this.account && this.APIName && this.version) {
                    this.start();
                } else {
                    this.loading = false;
                    this.messagesAndExceptions = 'Insufficient information to retrieve metrics';
                }
            });
        // }
    }

    start() {
        this.loading = true;
        this.messagesAndExceptions = null;
        this.displayPluginSuccessfullyConfigured = false;
        this.getServiceName().then(resp => {
            this.getPlugin().then(resp1 => {
                this.availableMetrics = [
                    {id: 0, itemName: 'Request Count', metric: 'sum:apiplatform.request.count{name:' + this.service + '}.as_count()'},
                    {id: 1, itemName: 'Latency .95 Percentile', metric: 'sum:apiplatform.latency.95percentile{name:' + this.service + '}'},
                    {id: 2, itemName: 'Average Latency', metric: 'avg:apiplatform.latency.avg{name:' + this.service + '}'},
                    {id: 3, itemName: 'Latency Count', metric: 'sum:apiplatform.latency.count{name:' + this.service + '}.as_count()'},
                    {id: 4, itemName: 'Max Latency', metric: 'max:apiplatform.latency.max{name:' + this.service + '}'},
                    {id: 5, itemName: 'Median Latency', metric: 'avg:apiplatform.latency.median{name:' + this.service + '}'},
                    {
                        id: 6,
                        itemName: 'Request Size .95 Percentile',
                        metric: 'sum:apiplatform.request.size.95percentile{name:' + this.service + '}'
                    },
                    {id: 7, itemName: 'Average Request Size', metric: 'avg:apiplatform.request.size.avg{name:' + this.service + '}'},
                    {
                        id: 8,
                        itemName: 'Request Size Count',
                        metric: 'sum:apiplatform.request.size.count{name:' + this.service + '}.as_count()'
                    },
                    {id: 9, itemName: 'Max Request Size', metric: 'max:apiplatform.request.size.max{name:' + this.service + '}'},
                    {id: 10, itemName: 'Median Request Size', metric: 'avg:apiplatform.request.size.median{name:' + this.service + '}'},
                    {
                        id: 11,
                        itemName: 'Response Size .95 Percentile',
                        metric: 'sum:apiplatform.response.size.95percentile{name:' + this.service + '}'
                    },
                    {id: 12, itemName: 'Average Response Size', metric: 'avg:apiplatform.response.size.avg{name:' + this.service + '}'},
                    {
                        id: 13,
                        itemName: 'Response Size Count',
                        metric: 'sum:apiplatform.response.size.count{name:' + this.service + '}.as_count()'
                    },
                    {id: 14, itemName: 'Max Response Size', metric: 'max:apiplatform.response.size.max{name:' + this.service + '}'},
                    {id: 15, itemName: 'Median Response Size', metric: 'avg:apiplatform.response.size.median{name:' + this.service + '}'},
                    {
                        id: 16,
                        itemName: 'Upstream Latency .95 Percentile',
                        metric: 'sum:apiplatform.upstream_latency.95percentile{name:' + this.service + '}'
                    },
                    {
                        id: 17,
                        itemName: 'Average Upstream Latency',
                        metric: 'avg:apiplatform.upstream_latency.avg{name:' + this.service + '}'
                    },
                    {
                        id: 18,
                        itemName: 'Upstream Latency Count',
                        metric: 'sum:apiplatform.upstream_latency.count{name:' + this.service + '}.as_count()'
                    },
                    {id: 19, itemName: 'Max Upstream Latency', metric: 'max:apiplatform.upstream_latency.max{name:' + this.service + '}'},
                    {
                        id: 20,
                        itemName: 'Median Upstream Latency',
                        metric: 'avg:apiplatform.upstream_latency.median{name:' + this.service + '}'
                    },
                    {id: 21, itemName: 'Total Request', metric: 'sum:apiplatform.request.count{name:' + this.service + '}.as_count()'},

                ];
                this.metricsToFind = [
                    {id: 21, itemName: 'Total Request', metric: 'sum:apiplatform.request.count{name:' + this.service + '}.as_count()'},
                    {id: 0, itemName: 'Request Count', metric: 'sum:apiplatform.request.count{name:' + this.service + '}.as_count()'},
                    {id: 1, itemName: 'Latency .95 Percentile', metric: 'sum:apiplatform.latency.95percentile{name:' + this.service + '}'},
                    {id: 2, itemName: 'Average Latency', metric: 'avg:apiplatform.latency.avg{name:' + this.service + '}'},
                ];
                this.loading = false;
                this.confpost.getEntity(this.partner, this.account, this.APIName, this.version).subscribe(exec => {
                    const temp = exec;
                    if (exec) {
                        this.creationTime = temp['creationTime'];
                        this.currentTime = Math.floor(Date.now() / 1000);
                        this.getOverAllRequestCount(this.creationTime, this.currentTime);
                        this.getAverageLatency(this.creationTime, this.currentTime);
                    }
                }, error1 => {
                    this.confpost.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account, this.APIName, this.version).subscribe(exec => {
                        const temp = exec;
                        if (exec) {
                            this.creationTime = temp['creationTime'];
                            this.currentTime = Math.floor(Date.now() / 1000);
                            this.getOverAllRequestCount(this.creationTime, this.currentTime);
                            this.getAverageLatency(this.creationTime, this.currentTime);

                        }
                    });
                });

                this.computeMetrics();
            }, error => {
                this.loading = false;
                this.messagesAndExceptions = error;
            });
        }, error => {
            this.loading = false;
            this.messagesAndExceptions = error;
        });
    }

    getServiceName() {
        return new Promise((resolve, reject) => {
            this.kong.getServicesFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + this.APIName + '-' + this.version).subscribe(response => {
                if (response) {
                    this.service = this.partner + '-' + this.account + '-' + this.APIName + '-' + this.version;
                    resolve('success');
                }
            }, error => {
                if (error && error.status === 404) {
                    this.kong.getServicesFromApiGatewayByNameOrId(this.partner + '-' + this.account + '-' + this.APIName).subscribe(response1 => {
                        if (response1) {
                            this.service = this.partner + '-' + this.account + '-' + this.APIName;
                            resolve('success');
                        }
                    }, error1 => {
                        if (error1 && error1.status === 404) {
                            reject('API Gateway is not configured for your API it seems. Please configure API Gateway by clicking on cog icon');
                        } else {
                            reject('Error while retrieving your gateway configurations. Sorry for the inconvenience');
                        }
                    });
                } else {
                    reject('Error while retrieving your gateway configurations. Sorry for the inconvenience');
                }
            });
        });
    }

    disableMonitoring(plugin) {
        return new Promise((resolve, reject) => {
            plugin['enabled'] = false;
            this.kong.patchPluginInApiGateway(plugin['id'], plugin).subscribe(response => {
                this.kong.getRoutesForAServiceFromApiGateway(this.service).toPromise().then(async route => {
                    await this.patchPluginsInAllRoutes(route, false);
                    resolve('success');
                }, error => {
                    resolve('failed');
                });
            }, error => {
                this.loading = false;
                this.isPluginNotAvailable = false;
                this.displayPluginSuccessfullyConfigured = false;
                this.messagesAndExceptions = 'Error while disabling Logging and Monitoring for your API. Sorry for the inconvenience. Please try again after sometime';
            });
        });
    }

    enableMonitoring(plugin) {
        return new Promise((resolve, reject) => {
            plugin['enabled'] = true;
            this.kong.patchPluginInApiGateway(plugin['id'], plugin).subscribe(response => {
                this.kong.getRoutesForAServiceFromApiGateway(this.service).toPromise().then(async route => {
                    await this.patchPluginsInAllRoutes(route, true);
                    resolve('success');
                }, error => {
                    resolve('failed');
                });
            }, error => {
                this.loading = false;
                this.isPluginNotAvailable = false;
                this.displayPluginSuccessfullyConfigured = false;
                this.messagesAndExceptions = 'Error while enabling Logging and Monitoring for your API. Sorry for the inconvenience. Please try again after sometime';
            });
        });
    }

    async patchPluginsInAllRoutes(gatewayRoute, status) {
        return new Promise(async (resolve, reject) => {
            for (let i = 0; i < gatewayRoute['data'].length; i++) {
                await this.patchPluginsInRoutesAlso(gatewayRoute, i, status);
                if (i === gatewayRoute['data'].length - 1) {
                    resolve('success');
                }
            }
        });
    }

    patchPluginsInRoutesAlso(gatewayRoute, index, status) {
        return new Promise((resolve, reject) => {
            this.kong.getPluginsForRouteInApiGateway(gatewayRoute['data'][index]['name']).subscribe(async plugins => {
                const pluginsConfiguredForRoute = plugins['data'];
                for (let i = 0; i < pluginsConfiguredForRoute.length; i++) {
                    if (pluginsConfiguredForRoute[i]['name'] === 'datadog') {
                        pluginsConfiguredForRoute[i]['enabled'] = status;
                        await this.patchPluginInAPIGateway(gatewayRoute['data'][index], pluginsConfiguredForRoute[i]['id'], pluginsConfiguredForRoute[i]).then(response1 => {
                            resolve('success');
                        }, error => {
                            resolve('failed');
                        });
                    } else {
                        resolve('failed');
                    }
                }
            }, error => {
                resolve('failed');
            });
        });
    }

    patchPluginInAPIGateway(route, id, plugin) {
        return new Promise((resolve, reject) => {
            this.kong.patchPluginInApiGateway(id, plugin).subscribe(response => {
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }

    configureMonitoring() {
        this.loading = true;
        this.kong.getPluginsForServiceByPluginNameInApiGateway(this.service, 'datadog').subscribe(async plugin => {
            if (plugin) {
                if (plugin['enabled'] === false) {
                    await this.enableMonitoring(plugin);
                    this.loading = false;
                    this.isPluginNotAvailable = false;
                    this.displayPluginSuccessfullyConfigured = true;
                    this.messagesAndExceptions = 'Congratulations... You have successfully enabled Logging and Monitoring for your API. We will be collecting the metrics for your API hereafter';
                } else if (plugin['enabled'] === true) {
                    await this.disableMonitoring(plugin);
                    this.loading = false;
                    this.isPluginNotAvailable = true;
                    this.displayPluginSuccessfullyConfigured = false;
                    this.messagesAndExceptions = 'You have successfully disabled Logging and Monitoring for your API. Please enable it to view your API metrics by clicking on the toggle below';
                }
            } else {
                const datadog = {
                    'name': 'datadog',
                    'enabled': true,
                    'config': {
                        'host': '127.0.0.1',
                        'port': 8125,
                        'prefix': 'apiplatform'
                    }
                };
                this.kong.createPluginForServiceInApiGateway(this.service, datadog).toPromise().then(response => {
                    this.kong.getRoutesForAServiceFromApiGateway(this.service).toPromise().then(async route => {
                        await this.createPluginsInAllRoutes(route, datadog);
                        this.loading = false;
                        this.isPluginNotAvailable = false;
                        this.displayPluginSuccessfullyConfigured = true;
                        this.messagesAndExceptions = 'Congratulations... You have successfully enabled Logging and Monitoring for your API. We will be collecting the metrics for your API hereafter';
                    }, error => {
                        this.loading = false;
                        this.isPluginNotAvailable = false;
                        this.displayPluginSuccessfullyConfigured = true;
                        this.messagesAndExceptions = 'Congratulations... You have successfully enabled Logging and Monitoring for your API. We will be collecting the metrics for your API hereafter';
                    });
                }, error => {
                    this.loading = false;
                    this.isPluginNotAvailable = false;
                    this.displayPluginSuccessfullyConfigured = false;
                    this.messagesAndExceptions = 'Error while enabling Logging and Monitoring for your API. Sorry for the inconvenience. Please try again after sometime';
                });
            }
        });
    }

    async createPluginsInAllRoutes(gatewayRoute, datadog) {
        return new Promise(async (resolve, reject) => {
            for (let i = 0; i < gatewayRoute['data'].length; i++) {
                await this.createPluginsInRoutesAlso(gatewayRoute, i, datadog);
                if (i === gatewayRoute['data'].length - 1) {
                    resolve('success');
                }
            }
        });
    }

    createPluginsInRoutesAlso(gatewayRoute, i, datadog) {
        return new Promise((resolve, reject) => {
            this.kong.createPluginForRouteInApiGateway(gatewayRoute['data'][i]['name'], datadog).toPromise().then(responseFromGateway => {
                resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }

    getPlugin() {
        return new Promise((resolve, reject) => {
            this.isPluginNotAvailable = false;
            this.kong.getPluginsForServiceByPluginNameInApiGateway(this.service, 'datadog').subscribe(plugin => {
                if (plugin) {
                    if (plugin['enabled'] === true) {
                        resolve('success');
                    } else {
                        this.isPluginNotAvailable = true;
                        reject('Oops!!! You have not configured Logging and Monitoring metrics for this API. No worries you can enable Logging and Monitoring by simply clicking on the toggle below');
                    }
                } else {
                    this.isPluginNotAvailable = true;
                    reject('Oops!!! You have not configured Logging and Monitoring metrics for this API. No worries you can enable Logging and Monitoring by simply clicking on the toggle below');
                }
            });
        });
    }

    computeMetrics() {
        return new Promise(async (resolve, reject) => {
            this.loadingMetrics = true;
            this.computedGraphs = [];
            this.metricsError = null;
            if (this.metricsToFind.length > 0) {
                for (let i = 0; i < this.metricsToFind.length; i++) {
                    const metric = this.metricsToFind[i];
                    if (metric) {
                        await this.generateGraph(metric);
                    }
                }
            } else {
                this.metricsError = 'Please select at least one metric to retrieve your API insights';
            }
            this.loadingMetrics = false;
            this.computedGraphs = this.getUniqueListBy(this.computedGraphs, 'embed_id');
        });
    }

    getUniqueListBy(arr, key) {
        return [...new Map(arr.map(item => [item[key], item])).values()]
    }

    generateGraph(metric) {
        return new Promise((resolve, reject) => {
            let payload = {};
            if (metric['itemName'] === 'Total Request') {
                payload = {
                    graph_json: {
                        'viz': 'query_value',
                        'requests': [
                            {
                                'response_format': 'scalar',
                                'queries': [
                                    {
                                        'name': 'query1',
                                        'data_source': 'metrics',
                                        'query': metric['metric'].toLowerCase(),
                                        'aggregator': 'sum'
                                    }
                                ],
                                'conditional_formats': [],
                                'formulas': [
                                    {
                                        'formula': 'query1'
                                    }
                                ]
                            }
                        ],
                        'precision': 2,
                        'autoscale': true,
                        'timeseries_background': {
                            'type': 'bars'
                        }
                    },
                    legend: 'yes',
                    timeframe: this.selectedTimeframe,
                    size: 'medium',
                    title: metric['itemName'] + ' : ' + this.APIName + ' (' + this.version + ')'
                };
            } else {
                payload = {
                    graph_json: {
                        'viz': 'timeseries',
                        'requests': [
                            {
                                'style': {
                                    'palette': 'dog_classic',
                                    'type': 'solid',
                                    'width': 'normal'
                                },
                                'type': this.selectedGraphDisplayType,
                                'formulas': [
                                    {
                                        'formula': 'query1'
                                    }
                                ],
                                'queries': [
                                    {
                                        'name': 'query1',
                                        'data_source': 'metrics',
                                        'query': metric['metric'].toLowerCase()
                                    }
                                ],
                                'response_format': 'timeseries'
                            }
                        ]
                    },
                    legend: 'yes',
                    timeframe: this.selectedTimeframe,
                    size: 'medium',
                    title: metric['itemName'] + ' : ' + this.APIName + ' (' + this.version + ')'
                };
            }
            this.confpost.getEmbeddedGraph(payload).subscribe(response => {
                if (response) {
                    this.computedGraphs.push(response);
                    resolve('success');
                }
            }, error => {
                this.metricsError = JSON.stringify(error['body']);
                resolve('failed');
            });
        });
    }

    getAverageLatency(from, to) {
     this.averageLatency = 0;
        from = Math.ceil(from / 1000);
        const payload = {
            'from': from,
            'to': to,
            'query': 'avg:apiplatform.latency.avg{name:' + this.service.toLowerCase() + '}'
        };
        this.confpost.getAverageLatencyfromDatadog(payload).subscribe(response => {
            let temp = response;
            if (response) {
                this.averageLatency = temp['average'];
                this.averageLatency = this.averageLatency.toFixed(2);
            }
        }, error => {
            this.averageLatency = 0;
        });
    }

    getOverAllRequestCount(from, to) {
        from = Math.ceil(from / 1000);
        const a = new Date(from * 1000);
        const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        const year = a.getFullYear();
        const month = months[a.getMonth()];
        const date = a.getDate();
        const hour = a.getHours();
        const min = a.getMinutes();
        const sec = a.getSeconds();
        const time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
        this.createdAt = time;
        let seconds = to - from;
        this.connectionTime = Math.floor(seconds / 60);
        const payload = {
            'from': from,
            'to': to,
            'query': 'sum:apiplatform.request.count{name:' + this.service.toLowerCase() + '}.as_count()'
        };

        this.confpost.getRequestCountfromDatadog(payload).subscribe(response => {
            let temp = response;
            if (response) {
                this.overAllRequestCount = temp['total'];
            }
        }, error => {
            this.overAllRequestCount = 'NA';
        });

    }

}
